import { render } from "./UpdateIndividualInfo.vue?vue&type=template&id=64f1f8ac&scoped=true"
import script from "./UpdateIndividualInfo.vue?vue&type=script&lang=js"
export * from "./UpdateIndividualInfo.vue?vue&type=script&lang=js"

import "./UpdateIndividualInfo.vue?vue&type=style&index=0&id=64f1f8ac&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1f8ac"]])

export default __exports__